(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2967],{

/***/ 63391:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 63391;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 46900:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/products/plp",
      function () {
        return __webpack_require__(39395);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7154);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={} , analyticsEvent , analyticsData  } = props;
    const isHomePage = (url)=>{
        return !url || url === _constants_index__WEBPACK_IMPORTED_MODULE_5__.HOMEPAGEURL ? "/" : url;
    };
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const ITEM_TYPE = {
        breadcrumbList: "http://schema.org/BreadcrumbList",
        listItem: "http://schema.org/ListItem"
    };
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url));
        setShortURLs(urls);
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).map((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        let path = "";
        for(let i = 0; i < index; i++){
            var ref;
            path += "".concat((ref = items[i].title) === null || ref === void 0 ? void 0 : ref.toLowerCase(), " > ");
        }
        if (!isSsr) {
            var ref1;
            let eventInfo = {
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: path + (navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                internalLinkPosition: eventPageName,
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: (navItem === null || navItem === void 0 ? void 0 : navItem.url) ? (navItem.url.indexOf("http") === -1 ? window.location.origin : "") + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url) : "n/a",
                internalLinkZoneName: eventPageName + ":" + zone
            };
            if (analyticsData) {
                eventInfo = {
                    ...eventInfo,
                    ...analyticsData
                };
            }
            return JSON.stringify(eventInfo);
        }
    };
    const handleClick = (navItem)=>{
        if (analyticsEvent) {
            analyticsEvent(navItem);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "breadcrumb ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
        children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            id: "breadcrumb",
            className: "cmp-breadcrumb",
            "aria-label": "Breadcrumb",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: "cmp-breadcrumb__list",
                itemScope: true,
                itemType: ITEM_TYPE.breadcrumbList,
                children: items.map((navItem, index)=>{
                    const isLastItem = index === items.length - 1;
                    const isActive = navItem.active;
                    const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "cmp-breadcrumb__item",
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: ITEM_TYPE.listItem,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isHomePage(shortURLs[index]),
                                className: "cmp-breadcrumb__item-link",
                                itemProp: "item",
                                "data-zone": zone,
                                "aria-label": navItem.title,
                                "aria-current": navItem.active ? "page" : null,
                                "data-gbh-data-layer": !analyticsEvent && !isSsr ? getEventInfo(navItem, index) : null,
                                onClick: ()=>handleClick(navItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    itemProp: "name",
                                    dangerouslySetInnerHTML: {
                                        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                    }
                                })
                            }),
                            shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "cmp-breadcrumb-slash",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                itemProp: "position",
                                content: index + 1
                            })
                        ]
                    }, "breadcrumb-item-".concat(index));
                })
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumb);


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33273);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55111);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_downloadFile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58589);












const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    // useEffect(() => {
    //   let timeoutId
    //   if (!isSsr) {
    //     timeoutId = setTimeout(() => {
    //       if (!accessToken || !isGuestTokenValid()) {
    //         dispatch(getOktaToken("guest"))
    //       }
    //     }, 5000)
    //   }
    //   ;() => {
    //     clearTimeout(timeoutId)
    //   }
    // }, [accessToken, isSsr])
    // useEffect(() => {
    //   const userLoggedIn = localStorage.getItem("userLoggedIn")
    //   if (userLoggedIn === "false" || userLoggedIn === null) {
    //     if (!isGuestTokenValid()) {
    //       dispatch(getAnonymousGuestToken())
    //     }
    //   }
    // }, [])
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getCurrency)().then((currency)=>{
                        const cartPayload = {
                            currency: currency
                        };
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                        });
                    });
                }
            });
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 39395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ plp; },
  "getServerSideProps": function() { return /* binding */ getServerSideProps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/serverSideTranslations.js
var serverSideTranslations = __webpack_require__(55709);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(3282);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 93 modules
var AemGrid = __webpack_require__(55064);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx + 1 modules
var GlobalPageFooter = __webpack_require__(74859);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./utils/cart.js + 1 modules
var cart = __webpack_require__(33273);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductList.jsx + 4 modules
var ProductList = __webpack_require__(79903);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./components/ProductList/v2/PLPLoader/index.jsx
var PLPLoader = __webpack_require__(80498);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/index.module.scss
var index_module = __webpack_require__(55266);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(50702);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/index.jsx + 3 modules
var UpsellInstallServices = __webpack_require__(24178);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(30534);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
;// CONCATENATED MODULE: ./components/Shared/data.json
var data_namespaceObject = JSON.parse('[{"indiaURL":"/p/washbasins","globalURL":"https://www.kohler.com/en/products/bathroom-sinks"},{"indiaURL":"/p/faucets","globalURL":"https://www.kohler.com/en/products/bathroom-faucets"},{"indiaURL":"/p/mirror-cabinets","globalURL":"https://www.kohler.com/en/products/mirrors-and-medicine-cabinets"},{"indiaURL":"/p/bathroom-vanity","globalURL":"https://www.kohler.com/en/products/vanities"},{"indiaURL":"/p/washbasins/shop-basin-fittings","globalURL":"https://www.kohler.com/en/products/bathroom-accessories/shop-bathroom-accessories"},{"indiaURL":"/p/bathroom-accessories","globalURL":"https://www.kohler.com/en/products/bathroom-accessories/shop-bathroom-accessories"},{"indiaURL":"/p/bathtubs","globalURL":"https://www.kohler.com/en/products/bathtubs"},{"indiaURL":"/p/showers","globalURL":"https://www.kohler.com/en/products/showers"},{"indiaURL":"/p/showers/shop-hand-showers","globalURL":"https://www.kohler.com/en/products/showers/shop-hand-showers"},{"indiaURL":"/p/diverters-trims","globalURL":"https://www.kohler.com/en/products/showers/shop-shower-trims-valves"},{"indiaURL":"/p/digital-showering","globalURL":"https://www.kohler.com/en/products/smart-shower"},{"indiaURL":"/p/shower-doors","globalURL":"https://www.kohler.com/en/products/showers/shop-shower-doors"},{"indiaURL":"/p/shower-doors/shop-shower-doors","globalURL":"https://www.kohler.com/en/products/showers/shop-shower-doors"},{"indiaURL":"/p/showers/shop-body-spray","globalURL":"https://www.kohler.com/en/products/showers/shop-body-sprays"},{"indiaURL":"/p/bathtub-fillers/bath-spouts","globalURL":"https://www.kohler.com/en/products/bathtubs/shop-bathtub-faucets"},{"indiaURL":"/p/bathtub-fillers","globalURL":"https://www.kohler.com/en/products/bathtubs/shop-bathtub-faucets"},{"indiaURL":"/p/shower-fittings","globalURL":"https://www.kohler.com/en/products/showers/shop-shower-fittings"},{"indiaURL":"/p/shower-fittings/shop-shower-fittings","globalURL":"https://www.kohler.com/en/products/showers/shop-shower-fittings"},{"indiaURL":"/p/toilets","globalURL":"https://www.kohler.com/en/products/toilets"},{"indiaURL":"/p/toilet-seats-bidet-seats","globalURL":"https://www.kohler.com/en/products/toilet-seats-bidet-seats"},{"indiaURL":"/p/smart-toilets","globalURL":"https://www.kohler.com/en/smart-toilets"},{"indiaURL":"/p/toilets/shop-health-faucets","globalURL":"https://me.kohler.com/product-category/bathroom/faucets/health-spray/"},{"indiaURL":"/p/toilet-seats-bidet-seats/shop-toilet-seats-and-bidet-seats","globalURL":"https://www.kohler.com/en/products/toilet-seats-bidet-seats/shop-bidet-seats-toilet-seats"},{"indiaURL":"/p/electronic-bidet-seats","globalURL":"https://www.kohler.com/en/products/toilet-seats-bidet-seats/shop-toilet-seats-bidet-seats"},{"indiaURL":"/p/smart-mirrors","globalURL":"https://www.kohler.com/en/products/mirrors"},{"indiaURL":"/p/toilet-seats-bidet-seats/shop-electronic-bidet-seats","globalURL":"https://www.kohler.com/en/products/toilet-seats-bidet-seats/shop-electric-toilet-seats"},{"indiaURL":"/p/faucets/sensor-faucets","globalURL":"https://www.kohler.com/en/products/commercial/shop-commercial-faucets"},{"indiaURL":"/p/urinals-sensors","globalURL":"https://www.kohler.com/en/products/commercial/shop-commercial-urinals"},{"indiaURL":"/p/customized-mirrors","globalURL":"https://www.kohler.com/en/products/mirrors-and-medicine-cabinets/shop-mirrors"},{"indiaURL":"/p/steam","globalURL":"https://www.kohler.com/en/products/showers/shop-steam-showering"},{"indiaURL":"/p/steam/shop-steam","globalURL":"https://www.kohler.com/en/products/showers/shop-steam-showering"},{"indiaURL":"/p/cleaners/shop-cleaner","globalURL":"https://www.kohler.com/en/products/cleaners/shop-cleaners"},{"indiaURL":"/p/kitchen-faucets","globalURL":"https://www.kohler.com/en/products/kitchen-faucets"},{"indiaURL":"/p/kitchen-faucets/shop-pulldown","globalURL":"https://www.kohler.com/en/products/kitchen-faucets/shop-pull-down-kitchen-faucets"},{"indiaURL":"/p/kitchen-faucets/shop-kitchen-faucets","globalURL":"https://www.kohler.com/en/products/kitchen-faucets/shop-kitchen-faucets"},{"indiaURL":"/p/stainless-steel-kitchen-sinks","globalURL":"https://www.kohler.com/en/products/kitchen-sinks/shop-stainless-steel-kitchen-sinks"},{"indiaURL":"/p/stainless-steel-kitchen-sinks/shop-stainless-steel-sinks","globalURL":"https://www.kohler.com/en/products/kitchen-sinks/shop-stainless-steel-kitchen-sinks"},{"indiaURL":"/p/stainless-steel-kitchen-sinks/shop-neoroc-composite-sinks","globalURL":"https://www.kohler.com/en/products/kitchen-sinks/shop-neoroc-kitchen-sinks"},{"indiaURL":"/p/kitchen-sinks/shop-kitchen-sinks","globalURL":"https://www.kohler.com/en/products/kitchen-sinks/shop-kitchen-sinks"},{"indiaURL":"/p/stainless-steel-kitchen-sinks/shop-kitchen-accessories","globalURL":"https://www.kohler.com/en/products/kitchen-accessories/shop-kitchen-accessories"},{"indiaURL":"/p/bathtubs/shop-bathtubs","globalURL":"https://www.kohler.com/en/products/bathtubs/shop-bathtubs"},{"indiaURL":"/p/bathtubs/shop-freestanding-bathtubs","globalURL":"https://www.kohler.com/en/products/bathtubs/shop-freestanding-bathtubs"},{"indiaURL":"/p/faucets/shop-bathtub-faucets","globalURL":"https://www.kohler.com/en/products/bathtubs/shop-bathtub-faucets"},{"indiaURL":"/p/faucets/shop-faucets","globalURL":"https://www.kohler.com/en/products/bathroom-faucets/shop-bathroom-sink-faucets"},{"indiaURL":"/p/faucets/shop-wall-mount-faucets","globalURL":"https://www.kohler.com/en/products/bathroom-faucets/shop-wall-mount-bathroom-sink-faucets"},{"indiaURL":"/p/faucets/shop-widespread-faucets","globalURL":"https://www.kohler.com/en/products/bathroom-faucets/shop-widespread-bathroom-sink-faucets"},{"indiaURL":"/p/showers/shop-showerheads","globalURL":"https://www.kohler.com/en/products/showers/shop-shower-heads"},{"indiaURL":"/p/showers/shop-steam-generators","globalURL":"https://www.kohler.com/en/products/showers/shop-steam-showering"},{"indiaURL":"/p/toilets/shop-one-piece","globalURL":"https://www.kohler.com/en/products/toilets/shop-one-piece-toilets"},{"indiaURL":"/p/toilets/shop-wall-hung-toilets","globalURL":"https://www.kohler.com/en/products/toilets/shop-wall-hung-toilets"},{"indiaURL":"/p/washbasins/shop-vanity-top-basin","globalURL":"https://www.kohler.com/en/products/bathroom-sinks/shop-vanity-top-bathroom-sinks"},{"indiaURL":"/p/washbasins/shop-vessel-basin","globalURL":"https://www.kohler.com/en/products/bathroom-sinks/shop-vessel-bathroom-sinks"},{"indiaURL":"/p/washbasins/shop-wall-mount-basin","globalURL":"https://www.kohler.com/en/products/bathroom-sinks/shop-wall-mount-bathroom-sinks"},{"indiaURL":"/p/washbasins/shop-washbasins","globalURL":"https://www.kohler.com/en/products/bathroom-sinks/shop-bathroom-sinks"}]');
;// CONCATENATED MODULE: ./page/products/plp.jsx































/**
 * renders home page
 * @return {JSX.Element}
 * @param {object} props The props.
 */ const Listing = (props)=>{
    const { tmpData: data , headertmp: header , footertmp: footer , ip , adobeAnalytic , globalScript , seoPageScript , footerScript , analyticsData , datalayerPageName , plpData , gbhDataLayerCustom , mappingData  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { cartUrl  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [pageRedirect, setPageRedirect] = (0,react.useState)("");
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = data || {};
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,usePageAuth/* default */.Z)();
    const cartCount = (0,cart/* getCartCount */.c0)();
    const ariaLabel = (0,cart/* getAriaLabel */.Xw)(t, cartCount);
    (0,react.useEffect)(()=>{
        (0,helper.getScriptsAndStyles)(footer);
    }, [
        footer
    ]);
    (0,react.useEffect)(()=>{
        (0,helper.getAnalyticsScript)(adobeAnalytic);
    }, [
        adobeAnalytic
    ]);
    (0,react.useEffect)(()=>{
        (0,helper.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,helper.removeAndCleanLink)(path));
        }
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react.useEffect)(()=>{
        // if (isSsr) return
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        if (plpData) {
            dispatch((0,productListSlice/* setPlpData */.gS)({
                ...plpData,
                status: "succeeded",
                initialLoad: true
            }));
        }
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, [
        datalayerPageName,
        gbhDataLayerCustom,
        plpData
    ]);
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,genericSlice/* closeMenu */.Wj)());
            dispatch((0,genericSlice/* setAuthNav */.AT)(false));
        } else {
            dispatch((0,genericSlice/* openMenu */.qn)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl,
            plp: {
                ...plpData,
                status: "succeeded"
            }
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,genericSlice/* setBrandLogoImg */.XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,genericSlice/* closeMenu */.Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,genericSlice/* setActiveMainCategory */.X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,genericSlice/* setRegionNav */.qX)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,genericSlice/* setAuthNav */.AT)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,genericSlice/* setGlobalScripts */.n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,genericSlice/* setGlobalStyles */.cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: data === null || data === void 0 ? void 0 : data.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: data === null || data === void 0 ? void 0 : data.title
                            })
                        ]
                    }),
                    (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: data === null || data === void 0 ? void 0 : data.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: data === null || data === void 0 ? void 0 : data.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "/en"
                    }),
                    (data === null || data === void 0 ? void 0 : data.templateName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: data === null || data === void 0 ? void 0 : data.templateName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                        header: header,
                        title: data === null || data === void 0 ? void 0 : data.title,
                        globalScripting: globalScript,
                        seoPageScripting: seoPageScript,
                        mappingData: mappingData
                    }),
                    (0,jsx_runtime.jsx)((style_default()), {
                        id: "4da4082d098430d2",
                        children: "@media print{@page{size:A4 portrait!important}}"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: data.id,
                        className: "jsx-4da4082d098430d2" + " " + (data.cssClassNames || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                            data: data,
                            count: 0,
                            eventHandler: eventHandler,
                            breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
                                    data: data,
                                    fullData: fullData
                                }),
                            productList: (data, eventHandler)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                                    data: data,
                                    eventHandler: eventHandler
                                }),
                            productListFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-4da4082d098430d2" + " " + "".concat((index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLPLoader/* default */.Z, {})
                                }),
                            upSellContainer: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellInstallServices/* default */.Z, {
                                    authData: data
                                }),
                            productAccordion: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                                    data: data,
                                    fullData: fullData
                                })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                        footer: footer,
                        footerScripting: footerScript
                    })
                ]
            })
        ]
    });
};
/**
 *
 * @param {*} context
 * @return {Object}
 */ async function getServerSideProps(param) {
    let { req , locale  } = param;
    var ref, ref1, ref2, ref3;
    if (!req.url) {
        console.log("No URL found in request", req.url);
        return {
            notFound: true
        };
    }
    await (esm/* i18n */.ag === null || esm/* i18n */.ag === void 0 ? void 0 : esm/* i18n.reloadResources */.ag.reloadResources());
    // let mappingData={}
    // const { url = "" } = req
    // const urlPathWithoutParams = url?.split("?")[0] ?? `/${locale}`
    // try{
    // const { data: configData = {} } = await aemAxiosInstance({
    //     url: `${CORE_GLOBAL_CONFIG_URL}?caConfig=true&path=/${locale}${urlPathWithoutParams}`,
    //     method: "GET",
    // })
    // if (!_isEmpty(configData)) {
    //     const {
    //       general: { productRangePath="" } = {},
    //     } = configData;
    //     ({ data: mappingData } = await aemAxiosInstance({
    //       url: `${CORE_GLOBAL_CONFIG_URL}?path=${productRangePath}`,
    //       method: "GET",
    //     }));
    //   }
    // }
    // catch(err){console.log(err, "error1")}
    const isPreviewMode = req.cookies["aem-author-preview-mode"];
    let plpData = {};
    const ip = (0,helper.getClienIP)(req);
    const urlPath = req.url.match(/^([^?#&]+)/)[1];
    let data;
    try {
        const response = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
            url: "".concat(constants.previewContentPrefix, "/").concat(locale).concat(urlPath, ".model.json"),
            method: "GET"
        }) : await (0,api/* aemApimAxiosInstance */.v0)({
            url: (0,helper.buildUrlForAemApim)("".concat(urlPath, ".model.json")),
            method: "GET"
        });
        data = response === null || response === void 0 ? void 0 : response.data;
    } catch (err) {
        console.log("Failed fetching PLP Model JSON data from AEM", err);
        return {
            notFound: true
        };
    }
    const globalScript = data === null || data === void 0 ? void 0 : data.globalScript;
    const footerScript = data === null || data === void 0 ? void 0 : data.footerScript;
    const topHeadScript = (data === null || data === void 0 ? void 0 : data.topHeadScript) ? data === null || data === void 0 ? void 0 : data.topHeadScript : null;
    const seoPageScript = (data === null || data === void 0 ? void 0 : data.seoPageScript) ? data === null || data === void 0 ? void 0 : data.seoPageScript : null;
    const gbhDataLayerCustom = {};
    if (data === null || data === void 0 ? void 0 : data.datalayerPageName) {
        gbhDataLayerCustom.datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    }
    if (data === null || data === void 0 ? void 0 : data.eventPageType) {
        gbhDataLayerCustom.eventPageType = data === null || data === void 0 ? void 0 : data.eventPageType;
    }
    if (data === null || data === void 0 ? void 0 : data.pageType) {
        gbhDataLayerCustom.pageType = data === null || data === void 0 ? void 0 : data.pageType;
    }
    if (!(data === null || data === void 0 ? void 0 : (ref = data.pageComponentProperties) === null || ref === void 0 ? void 0 : ref.description) && (data === null || data === void 0 ? void 0 : (ref1 = data.pageComponentProperties) === null || ref1 === void 0 ? void 0 : ref1.dataLayer) && (data === null || data === void 0 ? void 0 : (ref2 = data.pageComponentProperties) === null || ref2 === void 0 ? void 0 : ref2.dataLayer[data === null || data === void 0 ? void 0 : (ref3 = data.pageComponentProperties) === null || ref3 === void 0 ? void 0 : ref3.id])) {
        var ref4, ref5;
        gbhDataLayerCustom.dataLayer = data === null || data === void 0 ? void 0 : (ref4 = data.pageComponentProperties) === null || ref4 === void 0 ? void 0 : ref4.dataLayer[data === null || data === void 0 ? void 0 : (ref5 = data.pageComponentProperties) === null || ref5 === void 0 ? void 0 : ref5.id];
    }
    const categoryKey = (0,product/* getPlpParams */.Cb)(data, "categoryKey");
    const { data: header  } = await (0,api/* aemApimAxiosInstance */.v0)({
        url: data.headerExpFrg ? (0,helper.buildUrlForAemApim)("".concat(data.headerExpFrg, ".model.json")) : (0,helper.buildUrlForAemApim)("".concat(constants.headerUrl, ".model.json")),
        method: "get"
    });
    const { data: footer  } = await (0,api/* aemApimAxiosInstance */.v0)({
        url: data.footerExpFrg ? (0,helper.buildUrlForAemApim)("".concat(data.footerExpFrg, ".model.json")) : (0,helper.buildUrlForAemApim)("".concat(constants.footerUrl, ".model.json")),
        method: "GET"
    });
    const trimmedPath = urlPath.replace(/^\/+|\/+$/g, "");
    if (trimmedPath.split("/").length > 2 && categoryKey) {
        try {
            const data1 = await (0,product/* getListFromServer */.HK)(categoryKey, "GST");
            plpData = await (0,product/* formatListingData */.nx)(data1, true);
        } catch (error) {
            plpData = null;
            console.log("Error in getting PLP data", error);
        }
    }
    const analyticsData = data === null || data === void 0 ? void 0 : data.data;
    let tmpData = {};
    const adobeAnalytic = (data === null || data === void 0 ? void 0 : data.adobeAnalytic) || null;
    if (data.pageComponentProperties) {
        tmpData = data.pageComponentProperties;
    } else {
        tmpData = data;
    }
    tmpData = (0,helper.filterBackEndJson)(tmpData);
    const headertmp = (0,helper.filterBackEndJson)(header);
    const footertmp = (0,helper.filterBackEndJson)(footer);
    const datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    return {
        props: {
            ip,
            tmpData,
            headertmp,
            footertmp,
            adobeAnalytic,
            globalScript,
            footerScript,
            topHeadScript,
            seoPageScript,
            analyticsData,
            datalayerPageName,
            plpData,
            gbhDataLayerCustom,
            mappingData: data_namespaceObject,
            ...await (0,serverSideTranslations.serverSideTranslations)(locale, [
                "plp"
            ])
        }
    };
}
/* harmony default export */ var plp = (Listing);


/***/ }),

/***/ 58589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getToken; },
/* harmony export */   "S": function() { return /* binding */ downloadFile; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);



const downloadFile = (path, accessToken)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.downloadFileURL, "?fileName=").concat(path), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(accessToken)
                },
                responseType: "blob"
            });
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};
const getToken = async ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest&channel=india"));
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};


/***/ }),

/***/ 40816:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,33,5709,1433,6051,5576,4178,9774,2888,179], function() { return __webpack_exec__(46900); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);